import styled from 'styled-components'

interface IPageBottomContainerStyledProps {}

export const PageBottomContainerStyled = styled.div<IPageBottomContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
